export default function SpecBlock({ label, bold, splitBy }) {
  let splittedLabel = [];
  if (splitBy && label) {
    splittedLabel = label?.split(splitBy);
  }

  return (
    <>
      {splittedLabel.length > 0 && splittedLabel.val > 0 ? (
        splittedLabel.map((a, i) => (
          <div
            key={i}
            className={`${a ? "bg-white" : "bg-transparent"} ${
              bold ? "font-bold" : ""
            } min-h-[2.5rem] flex justify-center items-center text-center text-xs p-1`}
          >
            {a}
          </div>
        ))
      ) : (
        <div
          className={`${label ? "bg-olaf-green-300" : "bg-transparent"} ${
            bold ? "font-bold" : ""
          } min-h-[2.5rem] lg:min-h-[4rem] flex justify-center items-center text-center text-xs lg:text-base lg:font-semibold p-1`}
        >
          {label}
        </div>
      )}
    </>
  );
}
